import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { getApiUrl } from "../lib/queryClient";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function OAuthLogin() {
  const { logout } = useAuth();
  const [status, setStatus] = useState<{
    loggedIn: boolean;
    user?: any;
  } | null>(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    import("../lib/queryClient").then(({ apiRequest }) => {
      apiRequest("/api/auth/status")
        .then(setStatus)
        .catch(() => setStatus({ loggedIn: false }));
    });
  }, []);

  if (!status) return <div>Loading...</div>;
  if (!status.loggedIn) {
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        <p>需要登录Autodesk账号以访问此功能</p>
        <Button
          onClick={() => {
            setIsLoggingIn(true);
            window.location.href = getApiUrl("/api/auth/login");
          }}
          className="w-full"
          size="lg"
          disabled={isLoggingIn}
        >
          {isLoggingIn ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Logging in...
            </>
          ) : (
            'Login to Autodesk'
          )}
        </Button>
      </div>
    );
  }
  return (
    <div style={{ textAlign: "center", marginTop: 40 }}>
      <p>已连接 Autodesk</p>
      <button
        style={{ padding: "8px 24px", fontSize: 16 }}
        onClick={logout}
      >
        退出登录
      </button>
    </div>
  );
}
